<template>
  <div>
    <div class="d-flex align-items-center mb-3">
      <div>
        <h1 class="page-header mb-0">
          <i class="fa fa-bolt"></i> Feszültségmentesítési naplók
        </h1>
      </div>
    </div>
    <panel title="Feszültségmentesítések">
      <Loading
        title="Feszültségmentesítések betöltése"
        v-if="!isolations"
      ></Loading>
      <NoRecords
        title="Nincsenek feszültségmentesítések"
        v-else-if="isolations.length == 0"
      ></NoRecords>
      <vue-good-table
        v-else
        ref="table"
        @on-per-page-change="resetPage"
        @on-page-change="resetPage"
        @on-search="resetPage"
        :columns="columns"
        :rows="isolations"
        :lineNumbers="false"
        :search-options="{ enabled: false, placeholder: 'Keresés...' }"
        :pagination-options="{
          enabled: true,
          position: 'bottom',
          firstLabel: 'Első Lap',
          lastLabel: 'Utolsó Lap',
          nextLabel: 'következő',
          prevLabel: 'előző',
          rowsPerPageLabel: 'Sor oldalanként',
          ofLabel: '/',
          allLabel: 'Összes',
          infoFn: (params) => `első sorszám: ${params.firstRecordOnPage}`,
        }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'actions'">
            <router-link
              :to="'/logs/' + props.row.id + '/details'"
              class="btn btn-primary btn-xs mx-1"
              title="részletek"
              ><i class="fa fa-eye"></i
            ></router-link>
          </span>
          <span v-else-if="props.column.field == 'task_id'">
            <router-link
              :to="'/tasks/' + props.row.task_id + '/edit'"
              class="btn btn-dark btn-xs"
              title="munkafolyamathoz"
              >{{ props.row.task_id }} <i class="fa fa-paper-plane"></i
            ></router-link>
          </span>
          <span v-else-if="props.column.field == 'id'">
            <router-link
              :to="'/isolations/' + props.row.id + '/edit'"
              class="btn btn-dark btn-xs"
              title="feszültségmentesítéshez"
              >{{ props.row.id }} <i class="fa fa-paper-plane"></i
            ></router-link>
          </span>
          <span v-else-if="props.column.field == 'status'">
            <span v-if="isolation_statuses">
              {{
                isolation_statuses.find((is) => is.id == props.row.status).name
              }}
            </span>
            <loading mini v-else />
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
    </panel>
  </div>
</template>

<script>
import Loading from "../../components/Loading";
import NoRecords from "../../components/NoRecords";
import Log from "../../apis/Log";
export default {
  components: {
    Loading,
    NoRecords,
  },
  data() {
    return {
      isolations: false,
      columns: [
        {
          label: "Mf. száma",
          field: "task_id",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés",
          },
          tdClass: "fw-bold text-center",
          thClass: "fw-bold text-center",
        },
        {
          label: "Munkafolyamat megnevezése",
          field: "first_task_name",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés",
          },
          width: "20%",
        },
        {
          label: "Fm. száma",
          field: "id",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés",
          },
          tdClass: "fw-bold text-center",
          thClass: "fw-bold text-center",
        },
        {
          label: "Név",
          field: "position_name",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a nevek között",
          },
        },
        {
          label: "Pozíció",
          field: "position_id_ddc",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a pozíciók között",
          },
        },
        {
          label: "Kék lakat felvevő",
          field: "first_task_ddc_user_name",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a villanyszerelők között",
          },
        },
        {
          label: "Villanyszerelő",
          field: "electrician_name",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a villanyszerelők között",
          },
        },
        {
          label: "Kezdete",
          field: "started_at",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a dátumok között",
          },
        },
        {
          label: "Vége",
          field: "closed_at",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a dátumok között",
          },
        },
        {
          label: "Státus",
          field: "status",
          filterOptions: {
            enabled: true,
            placeholder: "Mind",
            filterDropdownItems: JSON.parse(
              localStorage.getItem("constants")
            ).isolation_status.map((s) => ({ value: s.id, text: s.name })),
          },
        },
        {
          label: "Műveletek",
          field: "actions",
          width: "15%",
          sortable: false,
          thClass: "text-end",
          tdClass: "text-end",
        },
      ],
      errors: [],
      isolation_statuses: false,
    };
  },
  created() {
    Log.index().then((response) => {
      this.isolations = response.data;
    });

    this.isolation_statuses = JSON.parse(
      localStorage.getItem("constants")
    ).isolation_status;
  },
  methods: {
    resetPage() {
      this.$refs.table.currentPage = 1;
    },
  },
};
</script>

<style></style>
